import Sortable from 'sortablejs'
import { JSONStringify, JSONParse } from '@/utils/jsonModification'
import { getUserTableSort, setUserTableSort } from '../../service/tableDrag'

function getColumnField(column) {
  const field = column?.property ?? column?.type

  return field === undefined || field === null || `${field}` === ''
    ? null
    : `${field}`
}

function getColumnFixedSide(column) {
  if (column?.fixed === 'right' || column?.fixed === true) return 'right'
  if (column?.fixed === 'left') return 'left'

  return 'none'
}

function getSavedColumnFixedSide(column) {
  if (column?.fixed === true) return 'right'
  if (column?.fixedLeft === true) return 'left'

  return 'none'
}

function getColumnDragKey(column) {
  const field = getColumnField(column)

  if (field) return `field:${field}`

  return `slot:${getColumnFixedSide(column)}:${column?.title || ''}`
}

function getSavedColumnDragKey(column) {
  if (column?.dragKey) return column.dragKey

  if (column?.field && column.field !== 'undefined') {
    return `field:${column.field}`
  }

  return `slot:${getSavedColumnFixedSide(column)}:${column?.title || ''}`
}

export default {
  bind: function (el, binding, vnode) {
    if (!binding.value) {
      console.warn(
        '⚠️：当前表格未开启表头拖拽，如若需要，请使用表格右侧自定义表头组件进行拖拽以及排序'
      )

      return
    }
    if (binding.value) {
      getUserTableSort(
        vnode.context.$store.state.user.id,
        'erp',
        vnode.context.$store.state.user.jobId,
        binding.value
      ).then((res) => {
        if (res.code === 200 && res.info && res.info.columns) {
          var serverCol = JSONParse(res.info.columns)
          var oldRenderCol = vnode.child.getColumns()

          var matchedRenderCol = []
          matchedRenderCol = serverCol
            .map((item2) => {
              const savedColumnDragKey = getSavedColumnDragKey(item2)

              return oldRenderCol.find(
                (item1) => getColumnDragKey(item1) === savedColumnDragKey
              )
            })
            .filter(Boolean) // 过滤掉服务端缓存中已不存在于当前表头的列（避免 find 返回 undefined 导致 loadColumn 崩溃）
          var matchedColumnKeys = new Set(
            matchedRenderCol.map(getColumnDragKey)
          )
          var unmatchedRenderCol = oldRenderCol.filter(
            (item) => !matchedColumnKeys.has(getColumnDragKey(item))
          )
          var newRenderCol = matchedRenderCol.concat(unmatchedRenderCol)

          // 只恢复排序，未命中的当前列要保留，避免旧缓存或错误 key 导致表格缺列
          if (
            matchedRenderCol.length > 0 &&
            newRenderCol.length === oldRenderCol.length
          ) {
            vnode.context.$nextTick(() => {
              vnode.child.loadColumn(newRenderCol)
            })
          }
        }
      })
    }

    // 拖拽时，生成dom
    var dragLoading = document.createElement('div')
    dragLoading.className = 'vxe-table--loading vxe-loading is--visible'
    dragLoading.style.display = 'none'
    dragLoading.innerHTML = `
			<div class="vxe-loading--spinner">

			</div>
		`
    el.querySelector('.vxe-table--header-wrapper').append(dragLoading)
    // el.style.cursor = 'move'
    new Sortable(el.querySelector('.vxe-header--row'), {
      draggable: 'th',
      handle: '.vxe-cell',
      animation: 500,
      direction: 'vertical',
      ghostClass: 'sortable-ghost',
      chosenClass: 'sortable-chosen',
      dragClass: 'sortable-drag',
      forceFallback: true,
      filter: '.col--checkbox',

      onEnd: async (e) => {
        var oldCol = vnode.child.getColumns()
        var oldTarget = oldCol.splice(e.oldIndex, 1)
        oldCol.splice(e.newIndex, 0, oldTarget[0])

        vnode.child.refreshColumn()
        await vnode.child.loadColumn([])
        vnode.context.$nextTick(() => {
          vnode.child.loadColumn(oldCol)
          // 保存排序信息
          var saveCol = []
          for (var i = 0; i < oldCol.length; i++) {
            saveCol.push({
              field: getColumnField(oldCol[i]),
              dragKey: getColumnDragKey(oldCol[i]),
              fixed: oldCol[i]['fixed'] === 'right',
              fixedLeft: oldCol[i]['fixed'] === 'left',
              title: oldCol[i]['title'] || ''
            })
          }
          if (binding.value) {
            setUserTableSort({
              userId: vnode.context.$store.state.user.id,
              projectName: 'erp',
              systemType: vnode.context.$store.state.user.jobId,
              tableId: binding.value,
              columns: JSONStringify(saveCol)
            })
          }

          dragLoading.style.display = 'none'
        })
      }
    })
  }
}
